import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { firstBook, viewUrl } from '../data/library';

/* The approved hero photograph, used exactly as supplied: the tablet, the
   Book 01 cover and the scene are all part of the image. Nothing is
   overlaid on top of it and nothing is cropped. */
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/5hpX8jc9De3TSnBbAVz1wL/little-engineers-hero-v2.png';
export function Hero() {
  return <section aria-labelledby="hero-heading" className="pt-10 sm:pt-14 lg:pt-16" data-id="element-178" data-mp="128pgl94mwp2g">
      <div className="grid items-center gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-179" data-mp="xbp8yts4ze98">
        <div data-id="element-180" data-mp="sa9slf0wlvx6">
          <h1 id="hero-heading" className="font-display text-[40px] font-bold leading-[1.04] text-navy sm:text-[52px] lg:text-[64px]" data-id="element-181" data-mp="s9q6dm480ldc">
            Your next build starts here.
          </h1>
          <p className="mt-5 max-w-[30rem] font-sans text-[18px] leading-relaxed text-navy/70" data-id="element-182" data-mp="3cz5to748dry8">
            Welcome to your Build &amp; Discover collection.
          </p>

          <a href={viewUrl(firstBook.fileId)} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-3 rounded-[18px] bg-sun px-6 py-4 font-display text-[16px] font-semibold text-navy transition-colors duration-150 ease-out hover:bg-[#F2B01C] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-183" data-mp="3j9265qny7uwl">
            Start with Book 01
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2.5} data-id="element-184" data-mp="359j8jrsrk1yj" />
          </a>

          <p className="mt-5 font-sans text-[13px] text-navy/50" data-id="element-185" data-mp="2ql68aimn7wy8">
            Digital guides • Read on screen or print at home
          </p>
        </div>

        <img src={HERO_IMAGE} alt="Book 01, My First Builds, open on a tablet on a craft table with cardboard, pencils and a child building a cardboard car" className="aspect-[3/2] w-full rounded-[20px] object-contain" data-id="element-186" data-mp="2hjf6vpz4yca6" />
      </div>
    </section>;
}